module.exports = __webpack_public_path__ + "static/media/mobile_meeting_link.b49fc91b.png";